import { Injectable } from '@angular/core';
import { EnvironmentService } from '../services/enviroment.service';
import { environment } from '../services/global-environment';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';  // 引入錯誤處理操作符
import { HttpClient, HttpParams } from '@angular/common/http';
import { TopicTagsResponse } from '../models/api-response.model';

// export type TargetContainer =  'form-container' | 'form-config' | 'regulation-container' | 'modules'  | 'users';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

 private apiUrl = environment.apiUrl;  // 從環境變數讀取後端 API URL

 constructor(private http: HttpClient) {}

// Get users (JWT: companyId is retrieved from backend)
getUsersByCompanyId() {
  const url = `${this.apiUrl}/api/users/getusers`;
  return this.http.get<any>(url);
}

// 將資料發送到後端 API
async sendDataToBackend(data: any, targetcontainer: string = "form-container"): Promise<any> {
  const url = `${this.apiUrl}/api/cosmosdb/saveData/${targetcontainer}`;
  try {
    const response = await this.http.post<any>(url, data).toPromise();
    return response;
  } catch (error) {
    console.error('Error sending data to backend:', error);
    throw error;
  }
}

// 呼叫 getDatabyquery API，並傳遞查詢參數
getDataByQuery(filter: any, pageSize: number = 10, targetcontainer: string): Observable<any> {
  const url = `${this.apiUrl}/api/cosmosdb/getDatabyquery/${targetcontainer}`;

  const params = new HttpParams()
    .set('filter', JSON.stringify(filter))
    .set('pageSize', pageSize.toString());

  return this.http.get<any>(url, { params });
}

getFormCount(companyid: string): Observable<any> {
  const url = `${this.apiUrl}/api/cosmosdb/getFormCount`;

  const params = new HttpParams()
    .set('companyid', companyid);

  return this.http.get<any>(url, { params });
}

get_compliance_tab_list(companyid: string, topic: string): Observable<any> {
  const url = `${this.apiUrl}/api/cosmosdb/get_compliance_tab_list`;

  const params = new HttpParams()
    .set('companyid', companyid)
    .set('topic', topic);

  return this.http.get<any>(url, { params });
}

get_compliance_result(companyid: string, topic: string, mission_name: string, law_id: string): Observable<any> {
  const url = `${this.apiUrl}/api/cosmosdb/get_compliance_regulation_and_result`;

  const params = new HttpParams()
    .set('companyid', companyid)
    .set('topic', topic)
    .set('mission_name', mission_name)
    .set('law_id', law_id);

  return this.http.get<any>(url, { params });
}

// 取得指定公司和主題下所有不重複的標籤
getTopicTags(companyid: string, topic: string): Observable<TopicTagsResponse> {
  const url = `${this.apiUrl}/api/regulation/get_tags`;

  const requestBody = {
    companyid: companyid,
    topic: topic
  };

  return this.http.post<TopicTagsResponse>(url, requestBody);
}

getexamquestions(courseName: string, numQuersion: number = 80): Observable<any> {
  const url = `${this.apiUrl}/api/examdb/getQuestions`;

  const params = new HttpParams()
    .set('courseName', courseName)
    .set('numQuestions', numQuersion.toString());

  return this.http.get<any>(url, { params });
}

// 更新資料到後端 API
async updateData(data: any, targetcontainer: string = "form-container"): Promise<any> {
  const url = `${this.apiUrl}/api/cosmosdb/updateData/${targetcontainer}`;
  try {
    const response = await this.http.put<any>(url, data).toPromise();
    console.log('Data successfully updated:', response);
    return response;
  } catch (error) {
    console.error('Error updating data:', error);
    throw error;
  }
}

// 從後端 API 刪除資料
async deleteData(id: string, targetcontainer: string = "form-container"): Promise<any> {
  const url = `${this.apiUrl}/api/cosmosdb/deleteData/${targetcontainer}/${id}`;
  try {
    const response = await this.http.delete<any>(url).toPromise();
    console.log('Data successfully deleted:', response);
    return response;
  } catch (error) {
    console.error('Error deleting data:', error);
    throw error;
  }
}

// 刪除表單及其相關資料
deleteForm(companyid: string, id: string): Observable<any> {
  const url = `${this.apiUrl}/api/form-manager/delete_form`;

  const requestData = {
    companyid: companyid,
    id: id
  };

  return this.http.post<any>(url, requestData);
}


}
